<script>
export default {
  props: {
    // 翻译内容
    contentAttributes: {
      type: Object,
      default: () => ({}),
    },
    // 原始消息内容
    content: {
      type: String,
      default: '',
    },
  },
  emits: ['close'],
  computed: {
    // 翻译内容是否可用
    translationsAvailable() {
      return !!Object.keys(this.translations).length;
    },
    // 翻译内容
    translations() {
      return this.contentAttributes.translations || {};
    },
  },
  methods: {
    onClose() {
      this.$emit('close');
    },
  },
};
</script>
<!-- 翻译模态框 -->
<template>
  <woot-modal
    modal-type="right-aligned"
    class="text-left"
    show
    :on-close="onClose"
  >
    <div class="content">
      <p>
        <b>{{ $t('TRANSLATE_MODAL.ORIGINAL_CONTENT') }}</b>
      </p>
      <p v-dompurify-html="content" class="mb-0" />
      <br />
      <hr />
      <div v-if="translationsAvailable">
        <p>
          <b>{{ $t('TRANSLATE_MODAL.TRANSLATED_CONTENT') }}</b>
        </p>
        <div v-for="(translation, language) in translations" :key="language">
          <p>
            <strong>{{ language }}:</strong>
          </p>
          <p v-dompurify-html="translation" />
          <br />
        </div>
      </div>
      <p v-else>
        {{ $t('TRANSLATE_MODAL.NO_TRANSLATIONS_AVAILABLE') }}
      </p>
    </div>
  </woot-modal>
</template>
